import React from 'react';

function EstimateBanner() {
	return (
		<div className='estimateContainer'>
			<h2>GET AN ESTIMATE ON YOUR HOME CLEANING</h2>
			<button>
				<a href='tel:318-323-8722'>GET A QUOTE</a>
			</button>
		</div>
	);
}

export default EstimateBanner;
